import React from "react";
import classes from './Layout.module.css';
import {Button, Grid, Icon} from "@material-ui/core";
import Header from "../../components/Navigtaion/Header/Header";
import Menu from "../../components/Menu/Menu";
import Arrows from "../../components/Navigtaion/Arrows/Arrows";
import { useMediaQuery } from 'react-responsive'
import * as actions from "../../store/actions";
import {connect} from "react-redux";
import routeData from "../../assets/static/routes.json";
import {withRouter} from "react-router-dom";

const getHeaderClass = (isTabletOrMobile, showSideNav) => {
	let clxList = [];
	clxList.push(classes.Header);
	if(isTabletOrMobile) {
		if(showSideNav) {
			clxList.push(classes.HeaderMobileOpen);
		} else {
			clxList.push(classes.HeaderMobileClose);
		}
	}
	return clxList.join(" ");
};

const handleNext = (props) => {
	let currentPath = props.location.pathname.replace('/', '');
	let routes = routeData.routes;
	let route = routes.filter(route => route.link === currentPath)[0];
	let nextRoute = (route.id >= routes.length-1 ) ? routes[0] : routes[route.id + 1];
	props.history.push(nextRoute.link)
};
const getNextRouteName = (props) => {
	let currentPath = props.location.pathname.replace('/', '');
	let routes = routeData.routes;
	let route = routes.filter(route => route.link === currentPath)[0];
	let nextRoute = (route.id >= routes.length-1 ) ? routes[0] : routes[route.id + 1];
	return nextRoute.name;
};
const Layout = (props) => {
	const isTabletOrMobile = useMediaQuery({ query: '(max-width: 600px)' })
	let toggleMenu = null;
	if(isTabletOrMobile) {
		if(props.showSideNav) {
			toggleMenu = <button className={classes.ClearToggle} onClick={() => props.toggleSideNav(false)}><Icon>clear_icon</Icon></button>;
		} else {
			toggleMenu = <button className={classes.MenuToggle} onClick={() => props.toggleSideNav(true)}><Icon>menu_icon</Icon></button>;
		}
	}
	return (
		<Grid
			container
			alignItems="center"
			justify="center"
			direction="column"
			className={classes.Layout}>
			<Grid item xs={"auto"} className={classes.Container}>
				<Grid container style={{height: '100%'}}>
					<Grid item xs={12} sm={4} className={getHeaderClass(isTabletOrMobile, props.showSideNav)}>
						<Header />
					</Grid>
					<div className={classes.Menu}>
						<Menu/>
					</div>
					<div className={classes.Arrows}>
						<Arrows/>
					</div>
					<Grid item xs={12} sm={8} className={classes.Main}>
						{toggleMenu}
						<div className={classes.Content}>
							<div>
								{!isTabletOrMobile &&
									<Button
										variant="contained" color="default"
										style={{float: 'right', marginRight: '30px'}}
										onClick={() => handleNext(props)}
										className={classes.NextRouteButton}
									>
										{getNextRouteName(props)}
										<Icon>skip_next</Icon>
									</Button>
								}
							</div>
							{props.children}
							<div>
								<Button
									variant="contained" color="default"
									style={{float: 'right', marginRight: '30px'}}
									onClick={() => handleNext(props)}
									className={classes.NextRouteButton}
								>
									{getNextRouteName(props)}
									<Icon>skip_next</Icon>
								</Button>
							</div>
						</div>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

const mapStateToProps = state => {
	return {
		showSideNav: state.root.showSideNav
	}
};
const mapDispatchToProps = dispatch => {
	return {
		toggleSideNav: (showSideNav) => dispatch( actions.toggleSideNav(showSideNav) )
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Layout));